import { getLocalStorage } from '../../utils/crud/crypt'
import { Roles } from '../../utils/enums'
import { Http } from '../../utils/types'
import { GetBlob, ObjectGeneric } from '../../utils/types/generals'
import {
  CatalogListResponse,
  CatalogByIdResponse,
  UserTypeAll,
  CreateOrUpdateResponse
} from './response'

export const catalogServise = (client: Http) => {
  return {
    getTableCatalogs: async ({ query }: { query?: string }): Promise<CatalogListResponse> => await client.get(`catalog/detailed${query ? '?' + query : ''}`),
    deleteCatalog: async (id: string) => await client.delete(`catalog/${id}`),
    editStatus: async (id: string) => await client.put(`catalog/${id}/switch`),
    getCatalogById: async (id: number | string): Promise<CatalogByIdResponse> => await client.get(`catalog/${id}`),
    userList: async (): Promise<UserTypeAll> => {
      const state = getLocalStorage()
      switch (state.role) {
        case Roles.ADMIN:
          return await client.get(`hierarchy`)
        default:
          return await client.get(`users/filters/template${state.company.id ? `?companies=${state.company.id}` : ''}`)
      }
    },
    createCatalog: async (body: ObjectGeneric): Promise<CreateOrUpdateResponse> => await client.post('catalog', body),
    updateCatalog: async (body: ObjectGeneric, id: number | string): Promise<CreateOrUpdateResponse> => await client.put(`catalog/${id}`, body),
    downloadFile: async (data: {
      type: `pdf` | 'word' | 'excel'
      query?: String
    }): Promise<GetBlob> =>
      await client.getBlob?.(
        `catalog/generate-file${data.query ? '?' + data.query + '&type=' + data.type : '?type=' + data.type}`
      ),
}
}
